/* global graphql  */
import 'babel-polyfill'
import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import favicon from '../assets/img/favicon.ico'
import avatar from '../assets/img/ATTN-PROFILE-WHITE-ON-ORANGE.jpg'

import '../assets/scss/main.scss'

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: 'Entertainment that informs.' },
        { property: 'og:url', content: 'https://www.attn.com' },
        { property: 'og:image', content: avatar },
        { property: 'og:site_name', content: 'ATTN:' },
        { property: 'og:title', content: 'ATTN:' },
        { property: 'og:type', content: 'website' },
        { name: 'msapplication-config', content: 'none' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: 'attn' }
      ]}
      link={[
        { rel: 'shortcut icon', type: 'image/x-icon', href: `${favicon}` },
        { rel: 'canonical', href: 'https://www.attn.com' }
      ]}
    />
    <div>
      {children()}
    </div>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
  data: PropTypes.object
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js